import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { salesDb } from "@/integrations/supabase/sales-client";

export type StudentSearchResult = {
  code: string;
  first_name: string | null;
  last_name: string | null;
  nickname: string | null;
  event_balance: number;
};

export const useFishsixStudentSearch = (search: string) => {
  return useQuery({
    enabled: search.trim().length >= 1,
    queryKey: ["fishsix-student-search-events", search],
    queryFn: async () => {
      const s = `%${search.trim()}%`;
      const { data, error } = await supabase
        .from("fishsix_students")
        .select("code,first_name,last_name,nickname")
        .eq("is_active", true)
        .is("deleted_at", null)
        .or(`code.ilike.${s},first_name.ilike.${s},last_name.ilike.${s},nickname.ilike.${s}`)
        .limit(20);
      if (error) throw error;
      const rows = (data ?? []) as any[];
      if (!rows.length) return [] as StudentSearchResult[];
      const codes = rows.map((r) => r.code);
      const { data: balances } = await salesDb()
        .from("v_student_event_balance")
        .select("fishsix_student_code,event_balance")
        .in("fishsix_student_code", codes);
      const bm = new Map<string, number>();
      (balances ?? []).forEach((b: any) =>
        bm.set(b.fishsix_student_code, Number(b.event_balance ?? 0))
      );
      return rows.map((r) => ({
        code: r.code,
        first_name: r.first_name,
        last_name: r.last_name,
        nickname: r.nickname,
        event_balance: bm.get(r.code) ?? 0,
      })) as StudentSearchResult[];
    },
  });
};
